import {
  deleteProjectApi,
  getProjectByIdApi,
  getProjectCountsApi,
  getProjectsApi,
  updateProjectStatusApi,
} from "../../services/ProjectService";
import { GET_PROJECT_BY_ID, GET_PROJECT_COUNTS, GET_PROJECTS } from "./ActionTypes";
import { loadingModel } from "./CommonActions";

export function getProjects({ page = 1, search = "", filters = [], limit = 10 }) {
  return (dispatch, getState) => {
    dispatch(loadingModel(true, GET_PROJECTS));
    getProjectsApi({ page, search, filters, limit }).then((response) => {
      // let posts = formatPosts(response.data);
      dispatch(loadingModel(false, GET_PROJECTS));
      dispatch(confirmedGetProjectsAction(response?.data?.data));
    });
  };
}

export function confirmedGetProjectsAction(data) {
  return {
    type: GET_PROJECTS,
    payload: data,
  };
}

export function getProjectById(id) {
  return (dispatch) => {
    dispatch(loadingModel(true, GET_PROJECT_BY_ID));
    getProjectByIdApi(id).then((response) => {
      dispatch(loadingModel(false, GET_PROJECT_BY_ID));
      dispatch(confirmedGetProjectByIdAction(response?.data?.data));
    });
  };
}

export function getProjectCounts() {
  return (dispatch) => {
    dispatch(loadingModel(true, GET_PROJECT_COUNTS));
    getProjectCountsApi().then((response) => {
      dispatch(loadingModel(false, GET_PROJECT_COUNTS));
      dispatch(confirmedGetProjectCountsAction(response?.data?.data));
    });
  };
}

export function confirmedGetProjectByIdAction(data) {
  return {
    type: GET_PROJECT_BY_ID,
    payload: data,
  };
}

export function confirmedGetProjectCountsAction(data) {
  return {
    type: GET_PROJECT_COUNTS,
    payload: data,
  };
}

export function updateProjectStatus(id, status) {
  return (dispatch) => {
    dispatch(loadingModel(true, "UPDATE_PROJECT_STATUS"));
    updateProjectStatusApi(id, status)
      .then((response) => {
        dispatch(loadingModel(false, "UPDATE_PROJECT_STATUS"));

        dispatch({
          type: GET_PROJECT_BY_ID,
          payload: response?.data?.data,
        });
      })
      .catch(() => {
        dispatch(loadingModel(false, "UPDATE_PROJECT_STATUS"));
      });
  };
}

export function deleteProjectAction(id, navigate) {
  return (dispatch, getState) => {
    deleteProjectApi(id)
      .then((response) => {
        //   dispatch(confirmedDeletePostAction(postId));
        // navigate.push("/users");
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong!";
        // toast.error(message);
        return error;
      });
  };
}
